export default {"src":"/_next/static/media/right-arrow.973333f8.svg","height":10,"width":16,"blurWidth":0,"blurHeight":0};